import ButtonConfirmation from './ButtonConfirmation';

export default ButtonConfirmation;